module.exports = __webpack_public_path__ + "resources/img/sp_ssl_ceritificate.d1778d790a52683bc1bf93b9e5dd7af2.png";